import { fetchFeatureFlagsAction, fetchCreatorFeatureFlagsAction } from './actions';
import { FORCE_NEW_EXPERIENCE } from './constants';

const initialState = {
  isFetching: false,
  flags: {},
  toggles: [],
  error: null,
  creatorForceNewExperience: false,
  isCreatorFlagsFetching: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case fetchFeatureFlagsAction.pending.toString(): {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }
    case fetchFeatureFlagsAction.fulfilled.toString(): {
      const { toggles = [] } = action.payload || {};
      const flags = toggles.reduce((acc, toggle) => {
        acc[toggle.name] = toggle.enabled;
        return acc;
      }, {});

      return {
        ...state,
        isFetching: false,
        flags,
        toggles
      };
    }
    case fetchFeatureFlagsAction.rejected.toString(): {
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    }
    case fetchCreatorFeatureFlagsAction.pending.toString(): {
      return {
        ...state,
        isCreatorFlagsFetching: true
      };
    }
    case fetchCreatorFeatureFlagsAction.fulfilled.toString(): {
      const { toggles = [] } = action.payload || {};
      const creatorForceNewExperience = toggles.some(
        (toggle) => toggle.name === FORCE_NEW_EXPERIENCE && toggle.enabled
      );

      return {
        ...state,
        isCreatorFlagsFetching: false,
        creatorForceNewExperience
      };
    }
    case fetchCreatorFeatureFlagsAction.rejected.toString(): {
      return {
        ...state,
        isCreatorFlagsFetching: false,
        creatorForceNewExperience: false
      };
    }
    default: {
      return state;
    }
  }
};
